"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CredentialMediaBlock_1 = __importDefault(require("../credentialMediaBlock/CredentialMediaBlock"));
const CredentialActionInfoBlock_1 = __importDefault(require("../credentialActionInfoBlock/CredentialActionInfoBlock"));
require("./mediaActionRow.scss");
const MediaActionRowLoader_1 = __importDefault(require("./mediaActionRowLoaders/MediaActionRowLoader"));
const styled_components_1 = __importDefault(require("styled-components"));
const master_1 = require("../../../constants/master");
const StyledMediaActionRow = styled_components_1.default.div `
  background: ${(props) => props.containerBackgroundColor} !important;
  .dynamic-text-color {
    color: ${(props) => props.containerTextColor} !important;
  }

  .more-div {
    border: 1px solid ${(props) => props.primaryColor} !important;

    .share-option {
      span {
        color: ${(props) => props.primaryColor} !important;
      }

      .customizable-icon .injected-svg {
        fill: ${(props) => props.primaryColor} !important;
        stroke: none !important;
      }
    }
  }
`;
function MediaActionRow(props) {
    const config = (0, master_1.getMasterConfig)();
    return props.loading ? (react_1.default.createElement(MediaActionRowLoader_1.default, { isMobile: props.isMobile })) : (react_1.default.createElement(StyledMediaActionRow, { containerTextColor: config.containerTextColor, containerBackgroundColor: config.containerBackgroundColor, primaryColor: config.primaryColor, className: "media-action-row" },
        react_1.default.createElement(CredentialMediaBlock_1.default, Object.assign({}, props)),
        react_1.default.createElement(CredentialActionInfoBlock_1.default, Object.assign({}, props))));
}
exports.default = MediaActionRow;
